<template>
  <auth-card
    title="Mot de passe oublié"
    subtitle="Inscrivez votre courriel. S'il existe dans nos systèmes, vous recevrez un lien pour choisir un nouveau mot de passe."
  >
    <v-alert v-if="errorMessage" class="mb-4" type="error" variant="tonal" density="compact">
      {{ errorMessage }}
    </v-alert>
    <v-alert v-if="successMessage" class="mb-4" type="success" variant="tonal" density="compact">
      {{ successMessage }}
    </v-alert>
    <v-form ref="form" v-model="valid" @submit="resetPassword" :disabled="isLoading">
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="Courriel"
        type="email"
        autocomplete="email"
        prepend-inner-icon="mdi-email-outline"
        class="mb-4"
        :disabled="isLoading"
        required
      ></v-text-field>
      <v-btn :disabled="!valid || isLoading" :loading="isLoading" color="primary" size="large" block type="submit">
        Envoyer le lien
      </v-btn>
    </v-form>
    <template #footer>
      <router-link :to="{ name: 'connexion' }" class="auth-link text-section-name font-weight-bold">
        <v-icon size="small" class="mr-1">mdi-arrow-left</v-icon>Retour à la connexion
      </router-link>
    </template>
  </auth-card>
</template>

<script>
  import { auth } from "@/firebase";
  import AuthCard from "@/components/AuthCard.vue";

  export default {
    components: { AuthCard },
    data() {
      return {
        valid: true,
        email: "",
        emailRules: [
          (v) => !!v || "Un courriel est requis",
          (v) => /.+@.+\..+/.test(v) || "Le courriel doit être valide",
        ],
        errorMessage: "",
        successMessage: "",
        isLoading: false,
      };
    },
    methods: {
      async resetPassword(evt) {
        evt.preventDefault();
        if (this.isLoading) return;
        this.isLoading = true;

        try {
          await auth.sendPasswordResetEmail(this.email);
          this.successMessage = "Courriel envoyé. Vérifiez votre boîte de réception (et les courriels indésirables).";
          this.errorMessage = "";
        } catch {
          this.errorMessage = "L'adresse courriel n'existe pas dans nos systèmes.";
          this.successMessage = "";
        } finally {
          this.isLoading = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .auth-link {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
  }

  .auth-link:hover {
    text-decoration: underline;
  }
</style>
